import { validationHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'

export function validate(values) {
    const errors = {}
    if (validationHelper.stringIsNullOrEmpty(values.employee_id) || values.employee_id == '0') {
        errors.employee_id = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.service_id) || values.service_id == '0') {
        errors.service_id = messages.MANDATORY_FIELD
    }

    return errors
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Reward/RewardList/_validate.js